import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import CreateOrganisationIndexCategoryInteractor from "../interactors/CreateOrganisationIndexCategoryInteractor";
import CreateOrganisationIndexGroupInteractor from "../interactors/CreateOrganisationIndexGroupInteractor";
import CreateOrganisationIndexInteractor from "../interactors/CreateOrganisationIndexInteractor";
import GetAllOrganisationIndexCategoriesInteractor from "../interactors/GetAllOrganisationIndexCategoriesInteractor";
import GetAllOrganisationIndexesInteractor from "../interactors/GetAllOrganisationIndexesInteractor";
import GetIndexTypeGroupTreeInteractor from "../interactors/GetIndexTypeGroupTreeInteractor";
import GetOrganisationIndexesForCaseLawDocumentInteractor from "../interactors/GetOrganisationIndexesForCaseLawDocumentInteractor";
import ShowOrganisationIndexCategoryInteractor from "../interactors/ShowOrganisationCategoryInteractor";
import ShowOrganisationIndexGroupInteractor from "../interactors/ShowOrganisationIndexGroupInteractor";
import UpdateOrganisationIndexCategoryInteractor from "../interactors/UpdateOrganisationIndexCategoryInteractor";
import OrganisationCategoryPage from "../ui/pages/OrganisationCategoryPage";
import OrganisationIndexGroupPage from "../ui/pages/OrganisationIndexGroupPage";

export default class OrganisationIndexDataArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "getAllOrganisationIndexCategories",
      GetAllOrganisationIndexCategoriesInteractor
    );
    container.registerInteractor(
      "getIndexTypeGroupTree",
      GetIndexTypeGroupTreeInteractor
    );
    container.registerInteractor(
      "showOrganisationIndexCategory",
      ShowOrganisationIndexCategoryInteractor
    );
    container.registerInteractor(
      "showOrganisationIndexGroup",
      ShowOrganisationIndexGroupInteractor
    );
    container.registerInteractor(
      "createOrganisationIndexCategory",
      CreateOrganisationIndexCategoryInteractor
    );
    container.registerInteractor(
      "createOrganisationIndexGroup",
      CreateOrganisationIndexGroupInteractor
    );
    container.registerInteractor(
      "createOrganisationIndex",
      CreateOrganisationIndexInteractor
    );
    container.registerInteractor(
      "updateOrganisationIndexCategory",
      UpdateOrganisationIndexCategoryInteractor
    );
    container.registerInteractor(
      "getOrganisationIndexesForCaseLawDocument",
      GetOrganisationIndexesForCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getAllOrganisationIndexes",
      GetAllOrganisationIndexesInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes(
      {
        path: "/organisations/:id/categories",
        page: this.createPage({
          Page: OrganisationCategoryPage,
          action: this.showOrganisationIndexCategoryPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/organisations/:id/categories/:categoryId",
        page: this.createPage({
          Page: OrganisationIndexGroupPage,
          action: this.showOrganisationIndexDataPage.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showOrganisationIndexDataPage({
    id,
    categoryId
  }: {
    id: string;
    categoryId: string;
  }) {
    return this.application.container
      .resolve<ShowOrganisationIndexGroupInteractor>(
        "showOrganisationIndexGroup"
      )
      .execute(Number.parseInt(id, 10), Number.parseInt(categoryId, 10));
  }
  public showOrganisationIndexCategoryPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationIndexCategoryInteractor>(
        "showOrganisationIndexCategory"
      )
      .execute(Number.parseInt(id, 10));
  }
}
